import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { FlatpickrDirectiveBase } from '../flatpickrDirectiveBase';
import flatpickr from 'flatpickr';
import Options = flatpickr.Options.Options;

@Directive({
  selector: '[appDateTimePicker]',
})
export class DatetimepickerDirective extends FlatpickrDirectiveBase implements OnInit {
  @Input() options?: Options;

  constructor(private el: ElementRef) {
    super(el, 'datetimepicker');
  }

  ngOnInit() {
    this.init(this.options);
  }
}
